import React, {FC, useState} from "react";
import {Employee} from "../../../lib/src/api/dto/Employee";
import {ModalFooter} from "../../../lib/src/components/layout/ModalProvider";
import {useApi} from "../api/APIContext";
import {getAvailableColors} from "../personel/components/EmployeeAvatar";
import {faSave} from "@fortawesome/free-solid-svg-icons";

export const EditEmployeeColorModal: FC<{ employee: Employee }> = ({ employee }) => {
  const {updateEmployeeMetadata} = useApi()
  const colors = getAvailableColors()
  const [initialValue, setInitialValue] = useState<string|null>(employee.metadata.color ?? null)
  const [selected, setSelected] = useState<string | null>(initialValue)
  const save = async () => {
    if (selected === null) {
      return
    }
    await updateEmployeeMetadata(employee.id, selected)
    setInitialValue(selected)
  }

  return <>
    <div className={"flex flex-wrap"}>
      {Object.entries(colors).map(([color, dot], i) => {
        return <button key={i} onClick={() => setSelected(color)} className={`h-8 w-8 flex items-center rounded-lg justify-center mb-2 mr-2 border-2 ${selected === color ? 'border-blue-900' : 'border-slate-200'}`}>
          <div className={`w-5 h-5 rounded-full full ${dot}`}></div>
        </button>
      })}
    </div>

    <ModalFooter text={'Opslaan'} icon={faSave} onSubmit={save} disabled={initialValue === selected} />
  </>
}